module.exports = __webpack_public_path__ + "img/img-chart-01.35fca7f5.png";